import { render, staticRenderFns } from "./alarm.vue?vue&type=template&id=fab0de4e&scoped=true"
import script from "./alarm.vue?vue&type=script&lang=ts"
export * from "./alarm.vue?vue&type=script&lang=ts"
import style0 from "./alarm.vue?vue&type=style&index=0&id=fab0de4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab0de4e",
  null
  
)

export default component.exports